if ( typeof QuickAddToCart !== 'function' ) {

	class QuickAddToCart extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('product-form') ) {
				this.init();
			}
		}
		init(){
			this.querySelector('.button').addEventListener('click', ()=>{
				this.closest('[data-js-product-item]').classList.add('null');
			});
			this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
				this.closest('[data-js-product-item]').classList.remove('null');
				if ( ! document.body.classList.contains('template-cart') ) {
					const quickAddButton = this.querySelector('.button');
					document.getElementById('site-cart-sidebar').show(quickAddButton);
					
					// Fetch cart data and dispatch cart-updated event for consistent updates
					fetch('/cart.js')
						.then(response => response.json())
						.then(cartData => {
							// Dispatch cart-updated event with cart data
							const cartUpdatedEvent = new CustomEvent('cart-updated', {
								bubbles: true,
								detail: {
									source: 'quick-buy',
									cartData: cartData,
								},
							});
							document.dispatchEvent(cartUpdatedEvent);
						})
						.catch(error => {
							console.error('Error fetching cart data:', error);
							// Fallback to direct updates
							document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
								elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
							});
							document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
								elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
							});
						});
				}
			});
		}
	}

  if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}

if ( typeof QuickViewProduct !== 'function' ) {

	class QuickViewProduct extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('.button') ) {
				this.init();
			}
		}
		init(){

			this.quickViewModal = null;
			this.querySelector('button').addEventListener('click', (e)=>{

				e.preventDefault();

				// Always create fresh modal - remove existing one if it exists
				// This prevents state contamination between different products
				if (this.quickViewModal) {
					this.quickViewModal.remove();
					this.quickViewModal = null;
				}

				const target = e.currentTarget;

				target.classList.add('working');
				target.closest('[data-js-product-item]').classList.add('null');

				// Clean up any existing quick view modals to prevent conflicts
				document.querySelectorAll('[id^="modal-"]').forEach(existingModal => {
					if (existingModal.classList.contains('modal--product')) {
						existingModal.remove();
					}
				});

				fetch(`${target.getAttribute('data-href')}${ target.getAttribute('data-href').includes('?') ? '&' : '?' }view=quick-view`)
					.then(response => response.text())
					.then(text => {

						const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');

						// create modal w content

						const quickViewContainer = document.createElement('div');
						quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"
							class="modal modal--product"
							data-options='{
								"enabled": false,
								"showOnce": false,
								"blockTabNavigation": true,
                "closeByKey": true,
                "openedModalBodyClass": "no-overflow"
							}'
							tabindex="-1" role="dialog" aria-modal="true"
						>
							<div class="product-modal-content" style="z-index:9"></div>
							<span class="modal-background" data-js-close></span>
						</modal-box>`;

						this.quickViewModal = quickViewContainer.querySelector('modal-box');
						document.body.appendChild(this.quickViewModal);

						this.quickViewModal.querySelector('.product-modal-content').innerHTML = `
              ${quickViewHTML.innerHTML}
              <button class="product-quick-view__close" data-js-close data-js-first-focus aria-label="Close quick view">${window.KROWN.settings.symbols.close}</button>
            `;

            ProductHeaderHelper(`#${this.quickViewModal.querySelector('product-page').id}`);
            
            // Force reinitialization of product-variants component for new product
            const productVariantsElement = this.quickViewModal.querySelector('product-variants');
            if (productVariantsElement) {
              // Clear any existing state and reinitialize
              productVariantsElement.variantData = null;
              productVariantsElement.currentVariant = null;
              productVariantsElement.options = [];
              
              // Trigger reinitialization
              if (typeof productVariantsElement.init === 'function') {
                productVariantsElement.init();
              }
            }

						if ( ! window.productPageScripts ) {
							const scripts = this.quickViewModal.querySelectorAll('script');
							scripts.forEach(elm=>{
								const script = document.createElement('script');
								script.src = elm.src;
								document.body.append(script);
								window.productPageScripts = true;
							});
						}

						// Always ensure TV selector script is loaded for modals
						if (!document.querySelector('script[src*="component-tv-brand-selector.js"]')) {
							const tvSelectorScript = document.createElement('script');
							tvSelectorScript.src = '/assets/component-tv-brand-selector.js';
							tvSelectorScript.defer = true;
							document.head.appendChild(tvSelectorScript);
						}

						// Wrap hide() so focus always returns to the trigger that opened this modal
						const triggerButton = target;
						const card = target.closest('[data-js-product-item]');

						// Closing the modal used to make the card jump, for two reasons:
						//
						// 1. focus() scrolls its target into view. On desktop the quick-view
						//    button is absolutely positioned and, while the card is not
						//    hovered, sits at translateY(100%) with opacity 0 — so the
						//    browser scrolled the page to that off-card phantom position.
						//    The card is already on screen (the modal was laid over it), so
						//    preventScroll is both safe and correct.
						//
						// 2. `null` was dropped as soon as the modal opened, so the button
						//    animated away under the modal and animated back on close. Hold
						//    it until the modal is actually gone and there is nothing to
						//    animate.
						const restoreCard = () => {
							if (card) card.classList.remove('null');
							triggerButton.focus({ preventScroll: true });
							// The card's :focus-within CSS keeps the quick-view button visible
							// (no hover needed) for as long as it holds focus — on purpose, so a
							// keyboard user closing the modal doesn't lose the focus ring. But a
							// mouse-driven close (background click) also lands focus here, and
							// without a keyboard interaction the browser won't paint a focus
							// ring — so the button was staying visible with nothing to justify
							// it, until the user focused something else. Release focus right
							// away when there's no ring to protect.
							if (!triggerButton.matches(':focus-visible')) {
								triggerButton.blur();
							}
						};

						const originalHide = this.quickViewModal.hide.bind(this.quickViewModal);
						this.quickViewModal.hide = (remember) => {
							originalHide(remember);
							restoreCard();
						};

						this.quickViewModal.querySelector('.product-quick-view__close').addEventListener('click', ()=>{
							this.quickViewModal.hide();
						});

						if ( this.quickViewModal.querySelector('[data-js-product-form]') ) {
							this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
								originalHide();
								if (card) card.classList.remove('null');
							});
						}

						if ( Shopify && Shopify.PaymentButton ) {
							setTimeout(()=>{
								Shopify.PaymentButton.init();
							}, 50);
						}

						setTimeout(()=>{
							this.quickViewModal.show();
							target.classList.remove('working');

							// Initialize quantity selector buttons in the modal
							initQuickViewQuantitySelectors(this.quickViewModal);

							// Enhanced initialization sequence to match cart footer success pattern
							setTimeout(() => {
								// Re-initialize quantity selectors after full render to catch any replaced elements
								initQuickViewQuantitySelectors(this.quickViewModal);

								// 1. Force reinitialization of product-variants component for new product
								const productVariantsElement = this.quickViewModal.querySelector('product-variants');
								if (productVariantsElement) {
									// Clear any existing state and reinitialize
									productVariantsElement.variantData = null;
									productVariantsElement.currentVariant = null;
									productVariantsElement.options = [];
									
									// Trigger reinitialization
									if (typeof productVariantsElement.init === 'function') {
										productVariantsElement.init();
									}
								}
								
								// 2. Initialize switch type selectors after product variants are ready
								if (typeof window.initSwitchTypeSelectors === 'function') {
									// Clear any previous switch type selections first
									const switchItems = this.quickViewModal.querySelectorAll('.switch-type-item');
									switchItems.forEach(item => {
										item.classList.remove('selected');
										item.setAttribute('aria-checked', 'false');
									});
									
									window.initSwitchTypeSelectors();
									
									// 3. Ensure switch items are always shown as available (like cart footer)
									ensureQuickViewSwitchItemsAvailable(this.quickViewModal);
								}
								
								// 4. Initialize TV brand selectors in the modal
								const tvBrandSelectors = this.quickViewModal.querySelectorAll('tv-brand-selector');
								if (tvBrandSelectors.length > 0) {
									// Initialize TV selectors if present
									setTimeout(() => {
										tvBrandSelectors.forEach((tvSelector) => {
											if (typeof TVBrandSelector !== 'undefined') {
												if (typeof tvSelector.init === 'function') {
													tvSelector.init();
												}
											} else if (customElements.get('tv-brand-selector')) {
												customElements.upgrade(tvSelector);
											}
										});
									}, 100);
								}
								
								// 5. Dispatch quickViewLoaded event for any other components
								const quickViewLoadedEvent = new CustomEvent('quickViewLoaded', {
									bubbles: true,
									detail: { 
										source: 'component-quick-buy',
										modalId: `modal-${target.dataset.id}`,
										modal: this.quickViewModal
									}
								});
								document.dispatchEvent(quickViewLoadedEvent);
							}, 500);
						}, 250);
						
					});

			});
		}
	}

  if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
		customElements.define('quick-view-product', QuickViewProduct);
	}

}

// Initialize +/– quantity selector buttons inside a quick view modal.
// product-quick-view.liquid renders plain HTML buttons (.quantity-decrease /
// .quantity-increase) — they have no handlers until this runs.
function initQuickViewQuantitySelectors(container) {
  if (!container) return;

  const quantitySelector = container.querySelector('.quantity-selector');
  if (!quantitySelector) return;

  const quantityInput = quantitySelector.querySelector('input[type="number"]');
  let decreaseButton = quantitySelector.querySelector('.quantity-decrease');
  let increaseButton = quantitySelector.querySelector('.quantity-increase');

  if (!quantityInput || !decreaseButton || !increaseButton) return;

  // Clone buttons to strip any previously attached listeners
  const newDecrease = decreaseButton.cloneNode(true);
  const newIncrease = increaseButton.cloneNode(true);
  decreaseButton.parentNode.replaceChild(newDecrease, decreaseButton);
  increaseButton.parentNode.replaceChild(newIncrease, increaseButton);

  function updateButtonStates() {
    const val = parseInt(quantityInput.value) || 1;
    newDecrease.disabled = val <= 1;
    newIncrease.disabled = val >= 99;
  }

  function changeQty(delta) {
    let val = parseInt(quantityInput.value) || 1;
    val = Math.max(1, Math.min(99, val + delta));
    quantityInput.value = val;
    quantityInput.setAttribute('aria-valuenow', val);
    updateButtonStates();
  }

  newDecrease.addEventListener('click', () => changeQty(-1));
  newIncrease.addEventListener('click', () => changeQty(1));

  quantityInput.addEventListener('input', function () {
    let val = parseInt(this.value) || 1;
    val = Math.max(1, Math.min(99, val));
    this.value = val;
    updateButtonStates();
  });

  quantityInput.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowUp') { e.preventDefault(); changeQty(1); }
    else if (e.key === 'ArrowDown') { e.preventDefault(); changeQty(-1); }
  });

  updateButtonStates();
}

// Helper function to ensure switch items are always shown as available (like cart footer)
function ensureQuickViewSwitchItemsAvailable(container) {
  if (!container) return;
  
  // Find all switch type items
  const switchItems = container.querySelectorAll('.switch-type-item');
  
  switchItems.forEach(item => {
    // Remove disabled class
    item.classList.remove('disabled');
    item.setAttribute('data-available', 'true');
    
    // Clear any availability messages
    const switchType = item.getAttribute('data-switch-type');
    if (switchType) {
      const messageEl = container.querySelector(`.availability-message[data-for="${switchType}"]`);
      if (messageEl) {
        messageEl.textContent = '';
      }
    }
  });
  
  // DO NOT auto-select - let validation enforce user selection
}

// Open quick-view modal from any trigger element (shared by QuickViewProduct and link delegation)
function openQuickViewModal(triggerEl, productUrl, productId) {
  document.querySelectorAll('[id^="modal-"]').forEach(m => {
    if (m.classList.contains('modal--product')) m.remove();
  });

  triggerEl.classList.add('working');

  const fetchUrl = `${productUrl}${productUrl.includes('?') ? '&' : '?'}view=quick-view`;

  fetch(fetchUrl)
    .then(r => r.text())
    .then(text => {
      const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');
      if (!quickViewHTML) { triggerEl.classList.remove('working'); return; }

      const container = document.createElement('div');
      container.innerHTML = `<modal-box id="modal-${productId}"
        class="modal modal--product"
        data-options='{"enabled":false,"showOnce":false,"blockTabNavigation":true,"closeByKey":true,"openedModalBodyClass":"no-overflow"}'
        tabindex="-1" role="dialog" aria-modal="true">
        <div class="product-modal-content" style="z-index:9"></div>
        <span class="modal-background" data-js-close></span>
      </modal-box>`;

      const modal = container.querySelector('modal-box');
      document.body.appendChild(modal);

      modal.querySelector('.product-modal-content').innerHTML = `
        ${quickViewHTML.innerHTML}
        <button class="product-quick-view__close" data-js-close aria-label="Close quick view">${window.KROWN.settings.symbols.close}</button>
      `;

      ProductHeaderHelper(`#${modal.querySelector('product-page').id}`);

      const originalHide = modal.hide.bind(modal);
      modal.hide = (r) => {
        originalHide(r);
        triggerEl.focus();
        // Same as the multi-variant path above: don't hold focus (and with it
        // the card's :focus-within reveal) past a mouse-driven close that
        // won't paint a focus ring anyway.
        if (!triggerEl.matches(':focus-visible')) {
          triggerEl.blur();
        }
      };

      modal.querySelector('.product-quick-view__close').addEventListener('click', () => modal.hide());

      if (modal.querySelector('[data-js-product-form]')) {
        modal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', () => originalHide());
      }

      if (!window.productPageScripts) {
        modal.querySelectorAll('script').forEach(elm => {
          const s = document.createElement('script');
          s.src = elm.src;
          document.body.append(s);
        });
        window.productPageScripts = true;
      }

      setTimeout(() => {
        modal.show();
        triggerEl.classList.remove('working');
        triggerEl.closest('[data-js-product-item]')?.classList.remove('null');
        initQuickViewQuantitySelectors(modal);

        setTimeout(() => {
          initQuickViewQuantitySelectors(modal);
          const pvEl = modal.querySelector('product-variants');
          if (pvEl) {
            pvEl.variantData = null; pvEl.currentVariant = null; pvEl.options = [];
            if (typeof pvEl.init === 'function') pvEl.init();
          }
          if (typeof window.initSwitchTypeSelectors === 'function') {
            ensureQuickViewSwitchItemsAvailable(modal);
            window.initSwitchTypeSelectors();
          }
        }, 500);
      }, 250);
    })
    .catch(() => {
      triggerEl.classList.remove('working');
    });
}

// Intercept clicks on .product-item__link--quickview and open modal instead of navigating.
// Delegates to the overlay quick-view button when present so only one modal ever opens.
document.addEventListener('click', (e) => {
  const link = e.target.closest('.product-item__link--quickview');
  if (!link) return;
  // Overlay button already handles itself — don't double-open
  if (e.target.closest('[data-js-product-add-to-cart]')) return;
  e.preventDefault();

  const productItem = link.closest('[data-js-product-item]');
  const qvBtn = productItem && productItem.querySelector('quick-view-product .button');

  if (qvBtn) {
    // Single trigger path: let QuickViewProduct open the modal
    qvBtn.click();
  } else {
    // Single-variant products have no quick-view button, open directly
    openQuickViewModal(link, link.dataset.productUrl, link.dataset.productId);
  }
});

// Helper function to select variant option in quickview context
function selectVariantOptionForQuickView(switchType, optionPosition, productContext) {
  // Try to find the variant selectors within the correct context
  const variantSelectors = productContext.querySelectorAll('[data-js-product-variant]');
  
  if (variantSelectors.length > optionPosition) {
    const targetVariantSelector = variantSelectors[optionPosition];
    const variantContainer = targetVariantSelector.querySelector('[data-js-product-variant-container]');
    
    if (variantContainer) {
      if (variantContainer.dataset.jsProductVariantContainer === 'radio') {
        // Handle radio buttons
        const radioInputs = variantContainer.querySelectorAll('input[type="radio"]');
        
        radioInputs.forEach(input => {
          if (input.value === switchType) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      } else {
        // Handle select dropdown
        const selectElement = variantContainer.querySelector('select') || variantContainer;
        if (selectElement && selectElement.tagName === 'SELECT') {
          const options = selectElement.querySelectorAll('option');
          options.forEach(option => {
            if (option.value === switchType) {
              selectElement.value = switchType;
              selectElement.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
      }
    }
  }
}